import React, { useState } from "react";
import noData from "../../../assets/Illustrations/emptyJobGuides.svg";
import { Link } from "react-router-dom";
import NoCreditModal from "./NoCreditModal";
import { Plus } from "lucide-react";

function YourGuidePageNoData({ moduleInfo, setSelectedTab }) {
  const [creditModalFlag, setCreditModalFlag] = useState(false);

  const switchToFreeGuides = () => {
    setSelectedTab("Free Guides");
  };

  return (
    <>
      {creditModalFlag && (
        <NoCreditModal
          creditModalFlag={creditModalFlag}
          setCreditModalFlag={setCreditModalFlag}
        />
      )}
      <div className="w-full flex flex-col gap-2 justify-center items-center mt-4 px-1">
        <img src={noData} width={400} alt="no-data" />
        <p className="text-[#475467] mt-2 text-[1rem] font-medium text-center max-w-[460px] mx-auto">
          No job guides available yet.
        </p>
        {/* <div className="mt-[.75rem] flex flex-col sm:flex-row gap-3 items-center justify-center">
          <button
            onClick={switchToFreeGuides}
            className="btn-white py-2 px-[1.2rem] text-[1rem] flex gap-[.65rem] items-center"
          >
            <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.50008 16.5L9.4167 16.3749C8.83783 15.5066 8.5484 15.0725 8.166 14.7582C7.82746 14.4799 7.43739 14.2712 7.01809 14.1438C6.54446 14 6.02267 14 4.9791 14H3.83341C2.89999 14 2.43328 14 2.07676 13.8183C1.76316 13.6586 1.50819 13.4036 1.3484 13.09C1.16675 12.7335 1.16675 12.2668 1.16675 11.3333V4.16667C1.16675 3.23325 1.16675 2.76654 1.3484 2.41002C1.50819 2.09641 1.76316 1.84144 2.07676 1.68166C2.43328 1.5 2.89999 1.5 3.83341 1.5H4.16675C6.03359 1.5 6.96701 1.5 7.68005 1.86331C8.30726 2.18289 8.81719 2.69282 9.13677 3.32003C9.50008 4.03307 9.50008 4.96649 9.50008 6.83333M9.50008 16.5V6.83333M9.50008 16.5L9.58346 16.3749C10.1623 15.5066 10.4518 15.0725 10.8342 14.7582C11.1727 14.4799 11.5628 14.2712 11.9821 14.1438C12.4557 14 12.9775 14 14.0211 14H15.1667C16.1002 14 16.5669 14 16.9234 13.8183C17.237 13.6586 17.492 13.4036 17.6518 13.09C17.8334 12.7335 17.8334 12.2668 17.8334 11.3333V4.16667C17.8334 3.23325 17.8334 2.76654 17.6518 2.41002C17.492 2.09641 17.237 1.84144 16.9234 1.68166C16.5669 1.5 16.1002 1.5 15.1667 1.5H14.8334C12.9666 1.5 12.0332 1.5 11.3201 1.86331C10.6929 2.18289 10.183 2.69282 9.86339 3.32003C9.50008 4.03307 9.50008 4.96649 9.50008 6.83333"
                stroke="#475467"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Explore free guides
          </button>

          <div>
            {moduleInfo?.credits > 0 ? (
              <Link to="/create-jd" className="inline-block ">
                <button className="btn-orange flex items-center gap-[.5rem] py-2 px-[1.2rem] text-[1rem] mx-auto ">
                  <Plus size={19} /> Create new
                </button>
              </Link>
            ) : (
              <button
                onClick={() => setCreditModalFlag(true)}
                className="btn-orange flex items-center gap-[.5rem] py-2 px-[1.2rem] text-[1rem] mx-auto "
              >
                <Plus size={19} /> Create new
              </button>
            )}
          </div>
        </div> */}
      </div>
    </>
  );
}

export default YourGuidePageNoData;
